<div class="px-8">
<p-card class="m-2">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-6">

    
    <div class="flex justify-between items-center border-b pb-4">
      <h2 class="text-xl font-bold text-gray-800">Adicionar Despesa</h2>

      <div class="flex items-center space-x-2">
        <p-checkbox formControlName="isPaid" binary="true" [ngClass]="{'ng-invalid ng-dirty': isFieldInvalid('isPaid')}"></p-checkbox>
        <span class="text-sm text-gray-700">Despesa Quitada *</span>
        <small class="text-red-500" *ngIf="isFieldInvalid('isPaid')">Campo obrigatório</small>
      </div>
    </div>


    
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">

      <div>
        <label class="block mb-1 text-sm font-medium text-gray-700">Descrição *</label>
        <input pInputText type="text" formControlName="description" class="w-full" [ngClass]="{'ng-invalid ng-dirty': isFieldInvalid('description')}" />
        <small class="text-red-500" *ngIf="isFieldInvalid('description')">Descrição é obrigatória</small>
      </div>

      <div>
        <label class="block mb-1 text-sm font-medium text-gray-700">Categoria da Despesa *</label>
        <p-dropdown
          [options]="expenseTypeOptions"
          formControlName="expenseTypeCategory"
          placeholder="Selecione uma categoria"
          [ngClass]="{'ng-invalid ng-dirty': isFieldInvalid('expenseTypeCategory')}"
          class="w-full">
        </p-dropdown>
        <small class="text-red-500" *ngIf="isFieldInvalid('expenseTypeCategory')">Categoria da despesa é obrigatória</small>
      </div>

      <div class="md:col-span-2 grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label class="block mb-1 text-sm font-medium text-gray-700">Tipo da Despesa *</label>
          <p-dropdown
            [options]="expenseTypeDropdownOptions"
            formControlName="expenseType"
            optionValue="value"
            placeholder="Selecione um tipo de despesa"
            [ngClass]="{'ng-invalid ng-dirty': isFieldInvalid('expenseType')}"
            class="w-full">
          </p-dropdown>
          <small class="text-red-500" *ngIf="isFieldInvalid('expenseType')">Tipo da despesa é obrigatório</small>
        </div>
        <div>
          <label class="block mb-1 text-sm font-medium text-gray-700">{{ customerLabel }} *</label>
          <p-dropdown
            [options]="customerDropdownOptions"
            formControlName="customer"
            optionValue="value"
            [placeholder]="'Selecione um ' + customerLabel.toLowerCase()"
            [ngClass]="{'ng-invalid ng-dirty': isFieldInvalid('customer')}"
            class="w-full">
          </p-dropdown>
          <small class="text-red-500" *ngIf="isFieldInvalid('customer')">{{ customerLabel }} é obrigatório</small>
        </div>
        <div>
          <label class="block mb-1 text-sm font-medium text-gray-700">Vencimento *</label>
          <p-calendar formControlName="dueDate" dateFormat="dd/mm/yy" showIcon="true" 
            [ngClass]="{'ng-invalid ng-dirty': isFieldInvalid('dueDate')}"
            class="w-full"></p-calendar>
          <small class="text-red-500" *ngIf="isFieldInvalid('dueDate')">Data de vencimento é obrigatória</small>
        </div>
      </div>

      <div class="md:col-span-2">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4 items-end">
          <div>
            <label class="block mb-1 text-sm font-medium text-gray-700">Valor *</label>
            <p-inputNumber formControlName="amount" mode="currency" currency="BRL" locale="pt-BR" 
              [ngClass]="{'ng-invalid ng-dirty': isFieldInvalid('amount')}"
              class="w-full"></p-inputNumber>
            <small class="text-red-500" *ngIf="isFieldInvalid('amount')">Valor é obrigatório e deve ser maior que 0</small>
          </div>
          <div class="flex items-end gap-2">
            <div class="flex-1">
              <label class="block mb-1 text-sm font-medium text-gray-700">Ocorrência *</label>
              <p-dropdown
                [options]="occurrenceOptions"
                formControlName="occurrence"
                placeholder="Selecione"
                [ngClass]="{'ng-invalid ng-dirty': isFieldInvalid('occurrence')}"
                class="w-full">
              </p-dropdown>
              <small class="text-red-500" *ngIf="isFieldInvalid('occurrence')">Ocorrência é obrigatória</small>
            </div>
            <button *ngIf="form.get('amount')?.value && form.get('occurrence')?.value === 'Parcelada/Recorrente'" pButton type="button" label="Configurar Parcelas" class="p-button-secondary whitespace-nowrap h-full" style="min-height: 38px;" (click)="openParcelModal()"></button>
          </div>
          <div></div>
        </div>
      </div>

      <div>
        <label class="block mb-1 text-sm font-medium text-gray-700">Conta Bancária *</label>
        <p-dropdown
          [options]="bankAccounts"
          optionLabel="accountName"
          optionValue="id"
          formControlName="bankAccount"
          placeholder="Selecione uma conta bancária"
          [ngClass]="{'ng-invalid ng-dirty': isFieldInvalid('bankAccount')}"
          class="w-full">
        </p-dropdown>
        <small class="text-red-500" *ngIf="isFieldInvalid('bankAccount')">Conta bancária é obrigatória</small>
      </div>

      <div>
        <label class="block mb-1 text-sm font-medium text-gray-700">Forma de Pagamento *</label>
        <p-dropdown
          [options]="typePaymentDropdownOptions"
          formControlName="paymentMethod"
          optionValue="value"
          placeholder="Selecione um método de pagamento"
          [ngClass]="{'ng-invalid ng-dirty': isFieldInvalid('paymentMethod')}"
          class="w-full">
        </p-dropdown>
        <small class="text-red-500" *ngIf="isFieldInvalid('paymentMethod')">Forma de pagamento é obrigatória</small>
      </div>

      <div>
        <label class="block mb-1 text-sm font-medium text-gray-700">% Juros *</label>
        <p-inputNumber formControlName="interest" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" 
          [ngClass]="{'ng-invalid ng-dirty': isFieldInvalid('interest')}"
          class="w-full"></p-inputNumber>
        <small class="text-red-500" *ngIf="isFieldInvalid('interest')">Juros é obrigatório e deve ser maior ou igual a 0</small>
      </div>

      <div>
        <label class="block mb-1 text-sm font-medium text-gray-700">% Multa *</label>
        <p-inputNumber formControlName="fine" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" 
          [ngClass]="{'ng-invalid ng-dirty': isFieldInvalid('fine')}"
          class="w-full"></p-inputNumber>
        <small class="text-red-500" *ngIf="isFieldInvalid('fine')">Multa é obrigatória e deve ser maior ou igual a 0</small>
      </div>

      <div class="md:col-span-2">
        <label class="block mb-1 text-sm font-medium text-gray-700">Código de Barras *</label>
        <input pInputText type="text" formControlName="barcode" 
          [ngClass]="{'ng-invalid ng-dirty': isFieldInvalid('barcode')}"
          class="w-full" />
        <small class="text-red-500" *ngIf="isFieldInvalid('barcode')">Código de barras é obrigatório</small>
      </div>

      <div class="md:col-span-2">
        <label class="block mb-1 text-sm font-medium text-gray-700">Observações</label>
        <textarea pInputTextarea formControlName="notes" rows="3" class="w-full"></textarea>
      </div>

    </div>

    
    <div class="pt-4 text-right">
      <button pButton type="submit" label="Salvar" icon="pi pi-save" class="p-button-primary"></button>
    </div>
  </form>
</p-card>

<p-dialog header="Configurar Parcelas" [(visible)]="showParcelModal" [modal]="true" [style]="{width: '900px'}">
  <div [formGroup]="form">
    <div *ngIf="form.get('occurrence')?.value === 'Parcelada/Recorrente'">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
        <div>
          <label class="block mb-1 text-sm font-medium text-gray-700">Intervalo de Pagamento *</label>
          <p-dropdown
            [options]="installmentIntervalOptions"
            formControlName="installmentInterval"
            placeholder="Selecione"
            class="w-full"
            appendTo="body">
          </p-dropdown>
        </div>
        <div>
          <label class="block mb-1 text-sm font-medium text-gray-700">Intervalo em Dias</label>
          <p-inputNumber formControlName="customIntervalDays" [disabled]="form.get('installmentInterval')?.value !== 'custom'" class="w-full"></p-inputNumber>
        </div>
        <div>
          <label class="block mb-1 text-sm font-medium text-gray-700">Quantidade de Parcelas *</label>
          <p-inputNumber formControlName="installmentCount" [min]="2" class="w-full"></p-inputNumber>
        </div>
        <div>
          <label class="block mb-1 text-sm font-medium text-gray-700">Data da 1ª Parcela *</label>
          <p-calendar formControlName="firstInstallmentDate" dateFormat="dd/mm/yy" showIcon="true" class="w-full" appendTo="body"></p-calendar>
        </div>
      </div>
      <div *ngIf="installments && installments.length > 0" class="bg-white shadow rounded overflow-x-auto">
        <p-table
          [value]="installments"
          [paginator]="false"
          styleClass="p-datatable-sm"
          [rowHover]="true"
          [stripedRows]="true"
          stripedRowsClass="bg-orange-50"
          [showCurrentPageReport]="false"
          responsiveLayout="scroll"
          class="min-w-full text-sm">
          <ng-template pTemplate="header">
            <tr class="bg-gray-100">
              <th class="text-left px-6 py-3">ID</th>
              <th class="text-left px-6 py-3">Data</th>
              <th class="text-left px-6 py-3">Valor</th>
              <th class="text-left px-6 py-3">Status</th>
              <th class="text-left px-6 py-3">Forma de Pagamento</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-inst let-i="rowIndex">
            <tr [ngClass]="i % 2 === 0 ? 'bg-white' : 'bg-orange-50'">
              <td class="px-6 py-2 font-semibold text-gray-900">{{ i + 1 }}</td>
              <td class="px-6 py-2">{{ inst.date | date: 'dd/MM/yyyy' }}</td>
              <td class="px-6 py-2">{{ inst.amount | currency: 'BRL':'symbol':'1.2-2' }}</td>
              <td class="px-6 py-2 align-middle">
                <p-dropdown [options]="installmentStatusOptions" [(ngModel)]="inst.status" [ngModelOptions]="{standalone: true}" [name]="'status' + i" class="w-full" appendTo="body"></p-dropdown>
              </td>
              <td class="px-6 py-2 align-middle">
                <p-dropdown [options]="typePaymentDropdownOptions" [(ngModel)]="inst.paymentMethod" [ngModelOptions]="{standalone: true}" [name]="'paymentMethod' + i" class="w-full" appendTo="body"></p-dropdown>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="5" class="text-center py-8 text-gray-500">
                Nenhuma parcela configurada
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <div class="pt-4 text-right">
        <button pButton type="button" label="Fechar" (click)="showParcelModal = false"></button>
      </div>
    </div>
  </div>
</p-dialog>
</div>
